import { get } from '../utils'

export const searchOptions = () => {
  return get('/search')
}

export const searchApi = {
  searchOptions
}
